import { Link } from 'react-router-dom';
import { ca } from '../i18n/ca';
import { Shell } from './Shell';

/**
 * A later step of the quick start opened with no server chosen (a reload in a
 * new tab, a shared link): the draft lives in the tab, so there is nothing to
 * show but the way back to the start. It used to be a bare link on an empty
 * page; it says why now.
 */
export function StartFromStepOne() {
  return (
    <Shell title={ca.newMission}>
      <section className="card empty-state">
        <i className="bi bi-signpost-split" aria-hidden="true" />
        <p>{ca.missionUi.noDraft}</p>
        <Link className="button primary" to="/new">
          {ca.step1}
        </Link>
      </section>
    </Shell>
  );
}
